export const DATE_CHANGE = 'DATE_CHANGE';
export const LOAD_PARTNER_OBJECTS = 'LOAD_PARTNER_OBJECTS';
export const USER_CHANGE = 'USER_CHANGE';
export const LOAD_MENUS = 'LOAD_MENUS';
export const QUANTITY_CHANGE = 'QUANTITY_CHANGE';
export const CHANGE_LOCATION = 'CHANGE_LOCATION';
export const MENU_ERROR = 'MENU_ERROR';
export const LOAD_OLD_MENUS = 'LOAD_OLD_MENUS';
export const CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION';



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/types.js
 **/